import React, { Component } from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  Card,
  Breadcrumbs,
  Link,
} from "@mui/material";
import CtBtn from "./CustomTool/CtBtn";
import CtCmb from "./CustomTool/CtCmb";
import CtDtp from "./CustomTool/CtDtp";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import CtMultiSelect from "./CustomTool/CtMultiSelect";
import CtTxtAmt from "./CustomTool/CtTxtAmt";
import CtTxt from "./CustomTool/CtTxt";
import TableList from "./CustomTool/TableList";
import { withRouter } from "../HOC/withRouter";
import "./ContractDetail.css";
import {
  get_30DaysBack_FromCurrentDate,
  get_YMD_from_SYS,
} from "../SystemUtility/SystemUtility";
import { Delete } from "@mui/icons-material";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import {
  mapSetUserPrivileges_ToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import BillingMaster from "./BillingMaster";
import { fetchBilling } from "./API";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";

class ContractDetail extends Component {
  state = {
    formData: {
      contractMode: "",
      contractType: [],
      contractTypeMulti: [],
      contractDate: get_YMD_from_SYS(new Date()),
      amcFromDate: get_30DaysBack_FromCurrentDate(new Date()),
      amcToDate: get_YMD_from_SYS(new Date()),
      paymentType: "",
      year: "",
      month: "",
      documentName: "",
      documentNo: "",
      documentDate: get_YMD_from_SYS(new Date()),
      documentFileName: "",
      documentRemark: "",
      paymentStatus: "",
      liftCount: "",
      advancePaymentDate: get_YMD_from_SYS(new Date()),
      advancePaymentMode: "",
      advanceReceiveAmount: "",
      advanceTdsAmount: "",
      advanceTotalAmount: "",
      advanceRemark: "",
      revisionNo: 0,
      branchCode: "BR-CODE",
      contractSrNo: 1,
      billingName: "",
    },
    BillingList: [],
    contractTypeItems: [{ name: "Regular" }, { name: "Popular" }],
    documentNameItems: ["Invoice", "Receipt", "Bill"],
    paymentColumns: [
      {
        id: "action",
        label: "",
        width: 40,
      },
      {
        id: "paymentFromDate",
        label: "Payment From Date",
        type: "CtDtp",
        CtrlProps: { width: 150, value: get_YMD_from_SYS(new Date()) },
      },
      {
        id: "paymentToDate",
        label: "Payment To Date",
        type: "CtDtp",
        CtrlProps: { width: 150, value: get_YMD_from_SYS(new Date()) },
      },
      {
        id: "regularPrice",
        label: "Regular Price",
        type: "CtTxtAmt",
        CtrlProps: { width: 120, maxLength: 10 },
      },
      {
        id: "popularPrice",
        label: "Popular Price",
        type: "CtTxtAmt",
        CtrlProps: { width: 120, maxLength: 10 },
      },
    ],
    paymentRows: [
      {
        ID: 1,
        paymentFromDate: "",
        paymentToDate: "",
        regularPrice: "100000",
        popularPrice: "100000",
      },
      {
        ID: 2,
        paymentFromDate: "",
        paymentToDate: "",
        regularPrice: "120000",
        popularPrice: "120000",
      },
    ],
    liftColumns: [
      { id: "liftName", label: "Lift Name" },
      {
        id: "yearlyTotalService",
        label: "Yearly Total Service",
        type: "CtTxtNum",
        CtrlProps: { width: 80, maxLength: 3 },
      },
    ],
    liftRows: [
      { ID: 1, liftName: "Lift A", yearlyTotalService: "12" },
      { ID: 2, liftName: "Lift B", yearlyTotalService: "14" },
    ],
  };
  componentDidMount() {
    if (
      this.props.location.state &&
      this.props.location.state.contract === "Existing AMC"
    ) {
      document.title = "Top India Elevator : Existing Contract Details";
      localStorage.setItem("Heading", "Existing Contract Details");
      document.getElementById("contractMode")?.focus();

      // localStorage.setItem("Heading", "Existing Contract Details");
    } else if (
      this.props.location.state &&
      this.props.location.state.contract === "New Contract"
    ) {
      document.title = "Top India Elevator : New Contract Details";
      localStorage.setItem("Heading", "New Contract Details");
    }
    document.getElementById("contractType")?.focus();
  }

  handleOnChange = (e) => {
    const { name, value } = e.target;
    if (name === "liftCount") {
      const sanitized = String(value).replace(/[^0-9]/g, "");
      const count = sanitized ? Number.parseInt(sanitized, 10) : 0;
      this.setState((prevState) => ({
        formData: { ...prevState.formData, liftCount: sanitized },
        liftRows: this.getLiftRowsForCount(count, prevState.liftRows),
      }));
      return;
    }

    this.setState((prevState) => ({
      formData: { ...prevState.formData, [name]: value },
    }));
  };

  handleDocFileChange = (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    this.setState({
      formData: {
        ...this.state.formData,
        documentFileName: file.name,
      },
    });
  };

  handlePaymentRowDataChange = (rows) => {
    this.setState({ paymentRows: rows });
  };

  handlePaymentActionClick = (rowData) => {
    if (rowData.actionName === "Delete") {
      const nextRows = this.state.paymentRows.filter(
        (row) => row.ID !== rowData.ID,
      );
      this.setState({ paymentRows: nextRows });
    }
  };

  handlePaymentAddRow = () => {
    const nextRows = [
      ...this.state.paymentRows,
      {
        ID: Date.now(),
        paymentFromDate: "",
        paymentToDate: "",
        regularPrice: "",
        popularPrice: "",
      },
    ];
    this.setState({ paymentRows: nextRows });
  };

  handleLiftRowDataChange = (rows) => {
    this.setState({ liftRows: rows });
  };

  getLiftRowsForCount = (count, prevRows) => {
    if (!count || count <= 0) return [];
    const baseId = Date.now();
    const nextRows = [];
    for (let index = 0; index < count; index += 1) {
      const existing = prevRows && prevRows[index];
      if (existing) {
        nextRows.push({ ...existing });
      } else {
        nextRows.push({
          ID: baseId + index,
          liftName: this.getDefaultLiftName(index),
          yearlyTotalService: "",
        });
      }
    }
    return nextRows;
  };

  getDefaultLiftName = (index) => {
    const alphaIndex = index % 26;
    const suffix =
      index < 26 ? String.fromCharCode(65 + alphaIndex) : index + 1;
    return `Lift ${suffix}`;
  };

  getFiscalYearLabel = (dateValue) => {
    const baseDate = dateValue ? new Date(dateValue) : new Date();
    const year = baseDate.getFullYear();
    const month = baseDate.getMonth() + 1;
    const startYear = month >= 4 ? year : year - 1;
    const endYear = startYear + 1;
    return `${String(startYear).slice(-2)}-${String(endYear).slice(-2)}`;
  };

  getDocumentNo = () => {
    const { revisionNo, branchCode, contractSrNo, contractDate } =
      this.state.formData;
    const fiscalYear = this.getFiscalYearLabel(contractDate);
    const base = `TOP/AMC/${branchCode}/${fiscalYear}/${contractSrNo}`;
    if (Number(revisionNo) > 0) {
      const revChar = String.fromCharCode(64 + Number(revisionNo));
      return `${base}/${revChar}`;
    }
    return base;
  };
  validationAMCContract = () => {
    const {
      contractMode,
      contractTypeMulti,
      contractDate,
      contractType,
      amcFromDate,
      amcToDate,
      paymentType,
      year,
      month,
      documentName,
      documentNo,
      documentDate,
      documentFileName,
      documentRemark,
      paymentStatus,
      liftCount,
    } = this.state.formData;

    const { paymentRows, liftRows, formData } = this.state;

    if (this.props.location.state?.contract === "Existing AMC") {
      if (!contractMode) {
        this.props.toastErrorMsg("Select Contract Type", "contractMode");
        return false;
      }
    }

    if (this.props.location.state?.contract === "New Contract") {
      if (!contractType || contractType.length === 0) {
        this.props.toastErrorMsg(
          "Select At Least One Contract Type",
          "contractType",
        );
        return false;
      }
    }

    if (!contractDate) {
      this.props.toastErrorMsg("Select Contract Date", "contractDate");
      return false;
    }

    if (!amcFromDate) {
      this.props.toastErrorMsg("Select AMC From Date", "amcFromDate");
      return false;
    }

    if (!amcToDate) {
      this.props.toastErrorMsg("Select AMC To Date", "amcToDate");
      return false;
    }
    if (!paymentType) {
      this.props.toastErrorMsg("Select Payment Type", "paymentType");
      return false;
    }
    if (this.props.location.state?.contract === "Existing AMC") {
      if (paymentType === "Advance") {
        if (!paymentStatus) {
          this.props.toastErrorMsg("Select Payment Status", "paymentStatus");
          return false;
        }
        if (!paymentType) {
          this.props.toastErrorMsg("Select Payment Type", "paymentType");
          return false;
        }

        if (!formData.advancePaymentDate) {
          this.props.toastErrorMsg("Select Payment Date", "advancePaymentDate");
          return false;
        }

        if (!formData.advancePaymentMode) {
          this.props.toastErrorMsg("Select Payment Mode", "advancePaymentMode");
          return false;
        }

        if (!formData.advanceReceiveAmount) {
          this.props.toastErrorMsg(
            "Enter Receive Amount",
            "advanceReceiveAmount",
          );
          return false;
        }

        if (!formData.advanceTotalAmount) {
          this.props.toastErrorMsg("Enter Total Amount", "advanceTotalAmount");
          return false;
        }
      }

      if (paymentType === "After Service") {
        if (!documentName) {
          this.props.toastErrorMsg("Select Document Name", "documentName");
          return false;
        }

        if (!documentNo) {
          this.props.toastErrorMsg("Enter Document No", "documentNo");
          return false;
        }

        if (!documentDate) {
          this.props.toastErrorMsg("Select Document Date", "documentDate");
          return false;
        }

        if (!documentFileName) {
          this.props.toastErrorMsg("Upload Document Image / PDF", "");
          return false;
        }

        if (!documentRemark) {
          this.props.toastErrorMsg("Enter Remark", "documentRemark");
          return false;
        }
      }
    }
    if (!year) {
      this.props.toastErrorMsg("Enter Year", "year");
      return false;
    }

    if (!month) {
      this.props.toastErrorMsg("Enter Month", "month");
      return false;
    }

    if (!liftCount || liftCount <= 0) {
      this.props.toastErrorMsg("Enter Lift Count", "liftCount");
      return false;
    }

    if (!liftRows || liftRows.length === 0) {
      this.props.toastErrorMsg("Enter Lift Details");
      return false;
    }

    return true;
  };

  saveContract = () => {
    if (this.validationAMCContract()) {
      this.props.toastMsg("success", "AMC Contract Save Successfully");
      this.clearInfo();
      this.props.location.state.contract === "Existing AMC"
        ? this.props.navigateTo("AMCList")
        : this.props.navigateTo("AMCRegistration");
    }
  };
  clearInfo = () => {
    this.setState({
      formData: {
        ...this.state.formData,

        contractMode: "Existing Contract",
        contractType: [],
        contractTypeMulti: [],

        contractDate: get_YMD_from_SYS(new Date()),
        amcFromDate: get_30DaysBack_FromCurrentDate(new Date()),
        amcToDate: get_YMD_from_SYS(new Date()),

        paymentType: "",
        year: "",
        month: "",

        documentName: "",
        documentNo: "",
        documentDate: get_YMD_from_SYS(new Date()),
        documentFileName: "",
        documentRemark: "",

        paymentStatus: "",
        liftCount: "",

        advancePaymentMode: "",
        advanceReceiveAmount: "",
        advanceTdsAmount: "",
        advanceTotalAmount: "",
        advanceRemark: "",
      },

      // paymentRows: [],
      // liftRows: [],
    });
    this.props.location.state.contract === "Existing AMC"
      ? document.getElementById("contractMode")?.focus()
      : document.getElementById("contractType")?.focus();
  };
  onAddClickBilling = () => {
    this.setState({ ARD: null }, () => {
      let ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          alertMessage={<BillingMaster />}
          defaultOpenDialog={true}
          handleOnClickNo={() => {
            this.getBillingList();
          }}
        />
      );
      this.setState({ ARD });
    });
  };

  getBillingList = () => {
    const reqData = {
      Op: "ListBillingMaster",
    };
    fetchBilling(reqData)
      .then((res) => {
        this.props.toastMsg("success", "Site List Loaded Successfully");
        let BillingList = res.data.BillingList;

        this.setState({
          BillingList,
        });
      })
      .catch((error) => {
        console.log("Unknown error occurred in onFormLoad.", error);
      });
    // document.getElementById("txtBranchCode").focus();
  };

  render() {
    const {
      formData,
      paymentColumns,
      paymentRows,
      liftColumns,
      liftRows,
      contractTypeItems,
      documentNameItems,
    } = this.state;
    console.log(
      "this.props.location.state.contract",
      this.props.location.state.contract,
    );

    return (
      <form>
        <Grid width="100">
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="#/Dashboard">
              Dashboard
            </Link>

            <Link underline="hover" color="inherit" href="#/AMCDashboard">
              AMC Dashboard
            </Link>

            <Link underline="hover" color="inherit" href="#/AMCList">
              AMC List
            </Link>

            {this.props?.location?.state?.contract !== "Existing AMC" && (
              <Link underline="hover" color="inherit" href="#/AMCRegistration">
                AMC Registration
              </Link>
            )}
            <Typography sx={{ color: "text.primary" }}>
              {this.props?.location?.state?.contract === "Existing AMC"
                ? "Existing Contract Details"
                : "New Contract Details"}
            </Typography>
          </Breadcrumbs>

          <Grid container spacing={2} marginBottom={3} direction={"row"}>
            <Grid item>
              <Grid container spacing={2} marginBottom={3}>
                {/* <Grid item>
                  <CtTxt
                    id="documentNoDisplay"
                    label="Document No"
                    value={this.getDocumentNo()}
                    width={320}
                    readOnly
                  />
                </Grid> */}
              </Grid>

              <Grid container spacing={2} marginTop={1}>
                {this.props.location.state &&
                this.props.location.state.contract === "Existing AMC" ? (
                  <Grid item>
                    <CtCmb
                      id="contractMode"
                      label="Contract Type*"
                      value={formData.contractMode}
                      items={contractTypeItems}
                      width={220}
                      colID="name"
                      handleOnChange={this.handleOnChange}
                      nextCtrlID={"contractType"}
                      onKeyDown={this.props.onKeyDown}
                    />
                  </Grid>
                ) : (
                  <Grid item>
                    <CtMultiSelect
                      id="contractType"
                      label="Contract Type*"
                      selectedItems={formData.contractType}
                      items={contractTypeItems}
                      width={240}
                      colID="name"
                      handleOnChange={this.handleOnChange}
                      nextCtrlID={"contractDate"}
                    />
                  </Grid>
                )}
              </Grid>

              <Grid container spacing={2} marginTop={0}>
                <Grid item>
                  <CtDtp
                    id="contractDate"
                    label="Contract Date*"
                    value={formData.contractDate}
                    width={170}
                    handleOnChange={this.handleOnChange}
                    nextCtrlID={"amcFromDate"}
                    onKeyDown={this.props.onKeyDown}
                  />
                </Grid>
                <Grid item>
                  <CtDtp
                    id="amcFromDate"
                    label="AMC From Date*"
                    value={formData.amcFromDate}
                    width={170}
                    nextCtrlID={"amcToDate"}
                    handleOnChange={this.handleOnChange}
                    onKeyDown={this.props.onKeyDown}
                  />
                </Grid>
                <Grid item>
                  <CtDtp
                    id="amcToDate"
                    label="AMC To Date*"
                    value={formData.amcToDate}
                    width={170}
                    handleOnChange={this.handleOnChange}
                    nextCtrlID={"paymentType"}
                    onKeyDown={this.props.onKeyDown}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} marginTop={0}>
                <Grid item>
                  <CtCmb
                    id="paymentType"
                    label="Payment Type*"
                    value={formData.paymentType}
                    items={["Advance", "After Service"]}
                    width={220}
                    handleOnChange={this.handleOnChange}
                    nextCtrlID={"year"}
                    onKeyDown={this.props.onKeyDown}
                  />
                </Grid>
                <Grid item>
                  <CtTxt
                    id="year"
                    label="Year*"
                    value={formData.year}
                    width={120}
                    maxLength={4}
                    handleOnChange={this.handleOnChange}
                    nextCtrlID={"month"}
                    onKeyDown={this.props.onKeyDown}
                  />
                </Grid>
                <Grid item>
                  <CtTxt
                    id="month"
                    label="Month*"
                    value={formData.month}
                    width={120}
                    maxLength={2}
                    handleOnChange={this.handleOnChange}
                    nextCtrlID={
                      this.props.location.state.contract === "Existing AMC"
                        ? "paymentStatus"
                        : "liftCount"
                    }
                    onKeyDown={this.props.onKeyDown}
                  />
                </Grid>
                {this.props.location.state &&
                this.props.location.state.contract === "Existing AMC" &&
                formData.paymentType === "Advance" ? (
                  <>
                    <Grid item>
                      <CtCmb
                        id="paymentStatus"
                        label="Payment Status*"
                        value={formData.paymentStatus}
                        items={["Paid", "Remain"]}
                        width={220}
                        nextCtrlID={
                          formData.paymentType === "After Service"
                            ? "documentName"
                            : "advancePaymentDate"
                        }
                        handleOnChange={this.handleOnChange}
                        onKeyDown={this.props.onKeyDown}
                      />
                    </Grid>
                  </>
                ) : null}
              </Grid>
              {this.props.location.state &&
              this.props.location.state.contract === "Existing AMC" ? (
                <>
                  {formData.paymentType === "After Service" ? (
                    <>
                      <Card
                        sx={{
                          color: "black",
                          height: "200px",
                          width: "900px",
                          padding: "2",
                          boxShadow: 2,
                          marginTop: 2,
                        }}
                      >
                        <Grid
                          container
                          spacing={2}
                          marginTop={0}
                          marginLeft={2}
                          direction={"column"}
                        >
                          <Grid item>
                            <Typography>Document Details</Typography>
                          </Grid>
                          <Grid item>
                            <Grid container spacing={2} alignItems={"center"}>
                              <Grid item>
                                <CtCmb
                                  id="documentName"
                                  label="Document Name*"
                                  value={formData.documentName}
                                  items={documentNameItems}
                                  width={220}
                                  handleOnChange={this.handleOnChange}
                                  nextCtrlID={"documentNo"}
                                  onKeyDown={this.props.onKeyDown}
                                />
                              </Grid>
                              <Grid item>
                                <CtTxt
                                  id="documentNo"
                                  label="Document No*"
                                  value={formData.documentNo}
                                  width={200}
                                  maxLength={50}
                                  handleOnChange={this.handleOnChange}
                                  nextCtrlID={"documentDate"}
                                  onKeyDown={this.props.onKeyDown}
                                />
                              </Grid>
                              <Grid item>
                                <CtDtp
                                  id="documentDate"
                                  label="Document Date*"
                                  value={formData.documentDate}
                                  width={120}
                                  handleOnChange={this.handleOnChange}
                                  nextCtrlID={"documentRemark"}
                                  onKeyDown={this.props.onKeyDown}
                                />
                              </Grid>
                              <Grid item>
                                <Button variant="outlined" component="label">
                                  Upload Img/Pdf
                                  <input
                                    type="file"
                                    hidden
                                    onChange={this.handleDocFileChange}
                                  />
                                </Button>
                                {formData.documentFileName ? (
                                  <Typography>
                                    {formData.documentFileName}
                                  </Typography>
                                ) : null}
                              </Grid>
                              <Grid item xs={12}>
                                <CtMultiLineText
                                  id="documentRemark"
                                  label="Remark*"
                                  value={formData.documentRemark}
                                  width={300}
                                  maxLength={1000}
                                  handleOnChange={this.handleOnChange}
                                  nextCtrlID={"liftCount"}
                                  onKeyDown={this.props.onKeyDown}
                                />
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Card>
                    </>
                  ) : null}
                </>
              ) : null}

              <Grid item marginTop={2}>
                {this.props.location.state &&
                this.props.location.state.contract === "Existing AMC" ? (
                  <>
                    {formData.paymentType === "Advance" ? (
                      <>
                        {/* <Typography className="existing-amc-section-title">
                    Advance Payment
                  </Typography> */}
                        <Card
                          sx={{
                            color: "black",
                            height: "200px",
                            width: "900px",
                            padding: "2",
                            boxShadow: 2,
                          }}
                        >
                          <Grid
                            container
                            marginTop={1}
                            spacing={2}
                            marginLeft={2}
                          >
                            <Grid item>
                              <Typography>Payment Cycle</Typography>
                            </Grid>
                          </Grid>
                          <Grid
                            container
                            spacing={2}
                            marginTop={0}
                            marginLeft={2}
                          >
                            <Grid item>
                              <CtDtp
                                id="advancePaymentDate"
                                label="Payment Date*"
                                value={formData.advancePaymentDate}
                                width={120}
                                handleOnChange={this.handleOnChange}
                                maxLength={100}
                                onKeyDown={this.props.onKeyDown}
                                nextCtrlID={"advancePaymentMode"}
                              />
                            </Grid>
                            <Grid item>
                              <CtCmbEditable
                                id="advancePaymentMode"
                                label="Payment Mode*"
                                value={formData.advancePaymentMode}
                                items={[
                                  {
                                    name: "Cash",
                                  },
                                  {
                                    name: "Cheque",
                                  },
                                  {
                                    name: "NEFT",
                                  },
                                  {
                                    name: "UPI",
                                  },
                                ]}
                                width={160}
                                handleOnChange={this.handleOnChange}
                                maxLength={100}
                                colID="name"
                                onKeyDown={this.props.onKeyDown}
                                nextCtrlID={"advanceReceiveAmount"}
                              />
                            </Grid>
                            <Grid item>
                              <CtTxtAmt
                                id="advanceReceiveAmount"
                                label="Receive Amount*"
                                value={formData.advanceReceiveAmount}
                                width={160}
                                maxLength={10}
                                handleOnChange={this.handleOnChange}
                                onKeyDown={this.props.onKeyDown}
                                nextCtrlID={"advanceTdsAmount"}
                              />
                            </Grid>
                            <Grid item>
                              <CtTxtAmt
                                id="advanceTdsAmount"
                                label="TDS Amount"
                                value={formData.advanceTdsAmount}
                                width={160}
                                maxLength={10}
                                handleOnChange={this.handleOnChange}
                                onKeyDown={this.props.onKeyDown}
                                nextCtrlID={"advanceTotalAmount"}
                              />
                            </Grid>
                            <Grid item>
                              <CtTxtAmt
                                id="advanceTotalAmount"
                                label="Total Amount*"
                                value={formData.advanceTotalAmount}
                                width={160}
                                maxLength={10}
                                handleOnChange={this.handleOnChange}
                                onKeyDown={this.props.onKeyDown}
                                nextCtrlID={"advanceRemark"}
                              />
                            </Grid>
                            <Grid item>
                              <CtMultiLineText
                                id="advanceRemark"
                                label="Remark"
                                value={formData.advanceRemark}
                                width={160}
                                maxLength={200}
                                handleOnChange={this.handleOnChange}
                                onKeyDown={this.props.onKeyDown}
                                nextCtrlID={"liftCount"}
                              />
                            </Grid>
                          </Grid>
                        </Card>
                      </>
                    ) : null}
                  </>
                ) : null}
              </Grid>
            </Grid>
          </Grid>
          <Box>
            <Grid container spacing={2}>
              <Grid item>
                <Grid item>
                  <CtCmbEditable
                    id="billingName"
                    label="Billing Name*"
                    width={200}
                    items={this.state.BillingList}
                    handleOnChange={this.handleOnChange}
                    value={this.state.formData.billingName}
                    maxLength={100}
                    nextCtrlID={"billingAddress"}
                    colID="vac_billingname"
                    onKeyDown={this.props.onKeyDown}
                    bolVisibleOnAddClickIcon={true}
                    onAddClick={this.onAddClickBilling}
                  />
                </Grid>
                <Grid item marginTop={1.5}>
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: 500,
                      color: "text.secondary",
                      fontSize: "0.8rem",
                    }}
                  >
                    Pan No.
                  </Typography>
                </Grid>
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  ABCDE1234F
                </Typography>
              </Grid>

              <Grid item>
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 500,
                    color: "text.secondary",
                    fontSize: "0.8rem",
                  }}
                >
                  Billing Address*
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 500, mb: 2 }}>
                  Plot No. 22, Sai Darshan park, Shubhashnagar, Ruva Gam,
                  Bhavnagar, Gujarat - 364001, GST No. 24AOXPP7835H1Z7
                </Typography>

                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 500,
                    color: "text.secondary",
                    fontSize: "0.8rem",
                  }}
                >
                  GST No.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  08ABCDE9999F1Z8
                </Typography>
              </Grid>
            </Grid>
          </Box>
          <Card
            sx={{
              color: "black",
              height: "260px",
              width: "935px",
              padding: "2",
              boxShadow: 2,
              marginTop: 2,
            }}
          >
            <Grid
              className="existing-amc-table-wrap"
              marginLeft={2}
              marginTop={2}
            >
              <Typography className="existing-amc-section-title">
                Payment Cycle
              </Typography>
            </Grid>
            <Grid
              className="existing-amc-table-wrap"
              marginLeft={2}
              marginTop={2}
            >
              <TableList
                columns={paymentColumns}
                rows={paymentRows}
                rowsCount={paymentRows.length}
                rowsPerPage={25}
                handleOnRowDataChange={this.handlePaymentRowDataChange}
                handleOnActionClick={this.handlePaymentActionClick}
                handleOnNewEntryClick={this.handlePaymentAddRow}
                actionList={[
                  {
                    name: "Delete",
                    icon: <Delete style={{ color: "#e53935" }} />,
                  },
                ]}
                noMobileLayout
              />
            </Grid>
          </Card>
          {/* LIFT COUNT */}
          <Grid container marginTop={2} marginBottom={2}>
            <Grid item>
              <CtTxt
                id="liftCount"
                label="Lift Count*"
                value={formData.liftCount}
                width={120}
                maxLength={3}
                handleOnChange={this.handleOnChange}
              />
            </Grid>
          </Grid>

          {/* LIFT TABLE */}
          <Box className="existing-amc-lift-table">
            <TableList
              columns={liftColumns}
              rows={liftRows}
              rowsCount={liftRows.length}
              rowsPerPage={25}
              handleOnRowDataChange={this.handleLiftRowDataChange}
              noMobileLayout
            />
          </Box>

          <Box className="existing-amc-footer">
            <CtBtn
              label="BACK"
              firstletterBig={false}
              className="child-button"
              variant="outlined"
              onClick={() =>
                this.props.location.state.contract === "Existing AMC"
                  ? this.props.navigateTo("AMCList")
                  : this.props.navigateTo("AMCRegistration")
              }
            />
            {this.props.location.state &&
            this.props.location.state.contract === "Existing AMC" ? (
              <CtBtn
                label="Save & Active"
                iconName="save"
                firstletterBig={false}
                className="secondary-button"
                onClick={() => this.saveContract()}
              />
            ) : (
              <CtBtn
                label="Save"
                iconName="save"
                firstletterBig={false}
                className="secondary-button"
                onClick={() => this.saveContract()}
              />
            )}
          </Box>
        </Grid>
        <Grid item>
          <div style={{ textAlign: "right" }}>{this.state.ARD}</div>
        </Grid>
      </form>
    );
  }
}

// export default withRouter(ContractDetail);

function WithNavigate(props) {
  const navigate = useNavigate();
  return <ContractDetail {...props} navigate={navigate} />;
}

export default connect(
  mapStatetoProps,
  mapSetUserPrivileges_ToProps,
)(HoCtToastContainer(HOCVerifyIsUser(withRouter(WithNavigate))));
